import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { MessageInfo } from "@42maru/webchat";
import { emptyPage, Page } from "@/model";
import conversationRepository from "@/repository/conversationRepository";


interface Props {
    scenarioId: string;
    conversationId: string;
    senderType?: string;
    condition?: string;
    position?: number;
    size?: number;
}

const getData = async (props: Props) => {
    const { scenarioId, conversationId, senderType, condition, position, size } = props;
    const res = await conversationRepository.findPaginatedMessagesWithPosition(scenarioId, conversationId, senderType, condition, position, size);
    return res.data || emptyPage<MessageInfo>();
};

export const useConversationMessagesByPosition = (props: Props): UseQueryResult<Page<MessageInfo>> => {
    const { scenarioId, conversationId, senderType, condition, position, size } = props;

    return useQuery<Page<MessageInfo>>({
        queryKey: ["messages", "byPosition", scenarioId, conversationId, senderType, condition, position, size],
        queryFn: () => getData({ scenarioId, conversationId, senderType, condition, position, size }),
        enabled: false
    });
};
